import { Array, Boolean, Null, Optional, Record, String } from 'runtypes';

import { DestinationCopyAccountRunType } from 'src/models/mail/extras';

export const MailListExtrasRunType = Record({
	answered: Boolean,
	answeredBy: String,
	answeredWithTheMailId: Null.Or(String),
	destinationCopyAccounts: Array(DestinationCopyAccountRunType),
	forwarded: Boolean,
	forwardedBy: String,
	hasAttachments: Boolean,
	isDeleted: Boolean,
	isSpam: Boolean,
	isTrash: Boolean,
	shouldShowTheClaimButton: Boolean,
	shouldShowTheReplyButton: Boolean,
	smtpLogDescription: Optional(String),
	smtpLogType: Optional(String),
	userIsAuthorizedToDelete: Boolean,
	userIsAuthorizedToSpam: Boolean,
});
